import { useDeviceProfileRegistration } from '@/hooks/useDeviceProfileRegistration';

export default function DeviceProfileRegistration() {
  useDeviceProfileRegistration();
  return null;
}
